import { createContext, FunctionComponent } from "preact";
import { useState } from "preact/hooks";
import {
  InterstitialQuestion,
  Question,
  QuestionAnswer,
} from "@/types/questions";
import { Product } from "@/types/products";

type Answers = Record<string, QuestionAnswer[]>;

type Variants =
  | "variant1"
  | "variant2"
  | "variant3"
  | "variant4"
  | "variant5"
  | "variant6";

interface AppContextType {
  questions: Question[] | InterstitialQuestion[];
  products: Record<string, Product>;
  answers: Answers;
  activeStep: number;
  interstitialVariant: Variants;
  setQuestions: (questions: Question[]) => void;
  setProducts: (products: Record<string, Product>) => void;
  setAnswers: (answers: Answers) => void;
  setActiveStep: (step: number) => void;
  setInterstitialVariant: (variant: Variants) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppContextProvider: FunctionComponent = ({ children }) => {
  const [questions, setQuestions] = useState<
    Question[] | InterstitialQuestion[]
  >([]);
  const [products, setProducts] = useState<Record<string, Product>>({});
  const [answers, setAnswers] = useState<Answers>({});
  const [activeStep, setActiveStep] = useState<number>(0);
  const [interstitialVariant, setInterstitialVariant] =
    useState<Variants>("variant1");

  const value: AppContextType = {
    questions,
    products,
    answers,
    activeStep,
    interstitialVariant,
    setQuestions,
    setProducts,
    setAnswers,
    setActiveStep,
    setInterstitialVariant,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
